import React from 'react'
import { Card, CardContent, CardMedia, CardActions, Button, Typography } from '@material-ui/core'

import useStyles from './style'

const CartItem = ({ item,handleUpdateCartQty,handleRemoveFromCart }) => {
  const classes = useStyles()
  // console.log(item)
  return (
    <Card>
      <CardMedia className={classes.media} image={item.media.source} alt={item.name}/>
      <CardContent className={classes.cardContent}>
        <Typography variant="h4">{item.name}</Typography>
        <Typography variant="h5">{item.line_total.formatted_with_symbol}</Typography>
      </CardContent>
      <CardActions className={classes.cardActions}>
        <div className={classes.cartActions}>
        <Button className={classes.buttons} type="button" type="small"
          onClick={() => handleUpdateCartQty(item.id, item.quantity - 1)}>-</Button>
        <Typography>{item.quantity}</Typography>
        <Button className={classes.buttons} type="button" type="small"
          onClick={() => handleUpdateCartQty(item.id, item.quantity + 1)}>+</Button>
        </div>
        <Button variant="contained" type="button" color="secondary"
          onClick={() => handleRemoveFromCart(item.id)}>Remove</Button>
      </CardActions>
    </Card>
  )
}

export default CartItem
